import React from 'react';

// Icônes au trait (style uniforme sur tout le site)
const PATHS = {
    login: (
        <>
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
            <path d="M10 17l5-5-5-5" />
            <path d="M15 12H3" />
        </>
    ),
    logout: (
        <>
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
            <path d="M16 17l5-5-5-5" />
            <path d="M21 12H9" />
        </>
    ),
    search: (
        <>
            <circle cx="11" cy="11" r="7" />
            <path d="M21 21l-4.3-4.3" />
        </>
    ),
    star: <path d="M12 3l2.8 5.7 6.2.9-4.5 4.4 1.1 6.2L12 17.3 6.4 20.2l1.1-6.2L3 9.6l6.2-.9z" />,
    shield: <path d="M12 3l8 3v6c0 4.5-3.4 8.3-8 9-4.6-.7-8-4.5-8-9V6z" />,
    user: (
        <>
            <circle cx="12" cy="8" r="4" />
            <path d="M4 21c0-4 3.6-7 8-7s8 3 8 7" />
        </>
    ),
    settings: (
        <>
            <circle cx="12" cy="12" r="3" />
            <path d="M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z" />
        </>
    ),
    home: (
        <>
            <path d="M3 10.5L12 3l9 7.5" />
            <path d="M5 9.5V20h14V9.5" />
            <path d="M10 20v-6h4v6" />
        </>
    ),
    sliders: (
        <>
            <path d="M4 6h10M18 6h2M4 12h4M12 12h8M4 18h12M20 18h0" />
            <circle cx="16" cy="6" r="2" />
            <circle cx="10" cy="12" r="2" />
            <circle cx="18" cy="18" r="2" />
        </>
    ),
    scale: (
        <>
            <path d="M12 3v18M7 21h10" />
            <path d="M5 7h14" />
            <path d="M5 7l-3 7a3 3 0 0 0 6 0z" />
            <path d="M19 7l-3 7a3 3 0 0 0 6 0z" />
        </>
    ),
    clock: (
        <>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
        </>
    ),
    trophy: (
        <>
            <path d="M8 4h8v5a4 4 0 0 1-8 0z" />
            <path d="M8 6H5a3 3 0 0 0 3 4M16 6h3a3 3 0 0 1-3 4" />
            <path d="M12 13v4M8 21h8M9 17h6v4H9z" />
        </>
    ),
    calendar: (
        <>
            <rect x="3" y="5" width="18" height="16" rx="2" />
            <path d="M3 10h18M8 3v4M16 3v4" />
        </>
    ),
    clipboard: (
        <>
            <rect x="5" y="4" width="14" height="17" rx="2" />
            <path d="M9 4V3h6v1M9 10h6M9 14h6M9 18h3" />
        </>
    ),
    chart: (
        <>
            <path d="M4 20V10M10 20V4M16 20v-7M22 20H2" />
        </>
    ),
    gem: (
        <>
            <path d="M6 3h12l4 6-10 12L2 9z" />
            <path d="M2 9h20M12 21L8 9l4-6 4 6z" />
        </>
    ),
    swords: (
        <>
            <path d="M14.5 17.5L3 6V3h3l11.5 11.5" />
            <path d="M13 19l6-6M16 16l4 4M19 21l2-2" />
            <path d="M9.5 6.5L21 18v3h-3l-3-3" />
        </>
    ),
    hourglass: (
        <>
            <path d="M6 3h12M6 21h12" />
            <path d="M7 3c0 5 10 5 10 9s-10 4-10 9M17 3c0 5-10 5-10 9s10 4 10 9" />
        </>
    ),
    chevronsLeft: (
        <>
            <path d="M11 17l-5-5 5-5" />
            <path d="M18 17l-5-5 5-5" />
        </>
    ),
    chevronsRight: (
        <>
            <path d="M13 17l5-5-5-5" />
            <path d="M6 17l5-5-5-5" />
        </>
    ),
    menu: <path d="M3 6h18M3 12h18M3 18h18" />,
    close: <path d="M6 6l12 12M18 6L6 18" />,
    arrowLeft: (
        <>
            <path d="M19 12H5" />
            <path d="M11 6l-6 6 6 6" />
        </>
    ),
    refresh: (
        <>
            <path d="M20 12a8 8 0 1 1-2.3-5.7L20 8.6" />
            <path d="M20 3v5.6h-5.6" />
        </>
    ),
    archive: (
        <>
            <rect x="3" y="4" width="18" height="5" rx="1" />
            <path d="M5 9v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9M10 13h4" />
        </>
    ),
    pencil: (
        <>
            <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L8 18l-4 1 1-4z" />
        </>
    ),
    trash: (
        <>
            <path d="M3 6h18M8 6V4h8v2M6 6l1 14h10l1-14" />
        </>
    ),
    check: <path d="M5 12.5l4.5 4.5L19 7" />,
    chevronDown: <path d="M6 9l6 6 6-6" />,
    chevronUp: <path d="M6 15l6-6 6 6" />,
    plus: <path d="M12 5v14M5 12h14" />,
    save: (
        <>
            <path d="M5 3h11l3 3v13a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2z" />
            <path d="M8 3v5h7M8 21v-7h8v7" />
        </>
    ),
    copy: (
        <>
            <rect x="9" y="9" width="12" height="12" rx="2" />
            <path d="M5 15H4a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1" />
        </>
    ),
    hash: <path d="M5 9h14M5 15h14M10 4L8 20M16 4l-2 16" />,
    hammer: (
        <>
            <path d="M14 5l5 5" />
            <path d="M11.5 7.5l5 5-2.5 2.5-5-5z" />
            <path d="M9 10l-6 6 2 2 6-6" />
            <path d="M4 21h9" />
        </>
    ),
    lock: (
        <>
            <rect x="5" y="11" width="14" height="10" rx="2" />
            <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </>
    ),
    pin: (
        <>
            <path d="M12 17v4" />
            <path d="M8 3h8l-1 6 3 4H6l3-4z" />
        </>
    ),
    swap: (
        <>
            <path d="M7 4L3 8l4 4M3 8h14" />
            <path d="M17 12l4 4-4 4M21 16H7" />
        </>
    ),
    grip: (
        <>
            <circle cx="9" cy="6" r="1" />
            <circle cx="15" cy="6" r="1" />
            <circle cx="9" cy="12" r="1" />
            <circle cx="15" cy="12" r="1" />
            <circle cx="9" cy="18" r="1" />
            <circle cx="15" cy="18" r="1" />
        </>
    ),
    list: <path d="M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01" />,
    terminal: (
        <>
            <rect x="3" y="4" width="18" height="16" rx="3" />
            <path d="M7 9l3 3-3 3M13 15h4" />
        </>
    ),
    map: (
        <>
            <path d="M9 4L3 6.5v13.5L9 17.5l6 2.5 6-2.5V4l-6 2.5z" />
            <path d="M9 4v13.5M15 6.5V20" />
        </>
    ),
    history: (
        <>
            <path d="M3 12a9 9 0 1 0 3-6.7L3 8" />
            <path d="M3 3v5h5M12 7v5l3 2" />
        </>
    ),
    backpack: (
        <>
            <path d="M6 9a6 6 0 0 1 12 0v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2z" />
            <path d="M9 5V4a3 3 0 0 1 6 0v1" />
            <path d="M9 14h6v4H9z" />
        </>
    ),
    image: (
        <>
            <rect x="3" y="4" width="18" height="16" rx="2" />
            <circle cx="9" cy="10" r="2" />
            <path d="M21 17l-5-5-9 8" />
        </>
    ),
    users: (
        <>
            <circle cx="9" cy="8" r="3.5" />
            <path d="M2.5 20c0-3.6 2.9-6 6.5-6s6.5 2.4 6.5 6" />
            <path d="M16 4.6a3.5 3.5 0 0 1 0 6.8" />
            <path d="M18 14.3c2.1.7 3.5 2.8 3.5 5.7" />
        </>
    ),
    arrowRight: (
        <>
            <path d="M5 12h14" />
            <path d="M13 6l6 6-6 6" />
        </>
    ),
};

const Icon = ({ name, size = 18, filled = false, strokeWidth = 2, ...rest }) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={filled ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        {...rest}
    >
        {PATHS[name]}
    </svg>
);

export default Icon;
